import { IState } from '../../../store';
import { getOfferType, FOfferType } from '../../../utils/offer_type';

export function isNewbuildingSelector(state: IState) {
  const { offer } = state.offerData;
  const offerType = getOfferType(offer);

  return offerType === FOfferType.FlatNew;
}
